import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import { headers as defaultHeaders } from './constants';

import Identity from './identity';
import { UserIdentity, isUserIdentity } from './userIdentity';
import { isSwgAccessTokenResponse } from './getSwgAccessToken';

import { deprecationMessage } from './googleSignOn';

export const relinkGoogleAccount = async (
  accessToken: string
): Promise<APIErrorResponse | Error | UserIdentity> => {
  console.error(deprecationMessage);

  const headers: { [index: string]: string } = { ...defaultHeaders };
  if (
    Identity.userIdentity &&
    Identity.userIdentity.accessToken &&
    Identity.userIdentity.refreshToken
  ) {
    await Identity.heartbeat();
    headers['Authorization'] = `Bearer ${Identity.userIdentity.accessToken}`;
  } else {
    throw new Error('[Arc Identity SDK] no logged in user found.');
  }
  const subscriptionToken = await Identity.getSwgAccessToken();
  if (!isSwgAccessTokenResponse(subscriptionToken)) {
    throw subscriptionToken;
  }

  return fetch(
    `${Identity.apiOrigin}/identity/public/v1/swg/${subscriptionToken.accessToken}/relink/${accessToken}`,
    {
      method: 'GET',
      headers
    }
  )
    .then(JSONResponseHandler)
    .then(response => {
      if (isUserIdentity(response)) {
        Identity.userIdentity = response;
        return response;
      } else {
        throw response;
      }
    });
};

export default relinkGoogleAccount;
